class ProductMobileQuickAddTrigger extends HTMLElement {
  constructor() {
    super();
    this.initializeElements();
  }

  initializeElements() {
    this.elements = {
      trigger: this.querySelector('[data-product-mobile-quick-add-trigger-el="trigger"]'),
    };

    this.externalElements = {
      slot: document.querySelector('[data-product-mobile-quick-add-trigger-external-el="slot"]'),
    };
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.elements.trigger) {
      this.elements.trigger.addEventListener('touchstart', this.handleOpen.bind(this));

    } else {
      console.error('Trigger element not found');
    }
  }

  async handleOpen(event) {
    event.preventDefault();
    event.currentTarget.click();

    const currentProductHandle = document.querySelector('[data-product-mobile-quick-add-el="dialog"]')?.dataset.productHandle;

    if(this.dataset.productHandle === currentProductHandle) {
      this.showDialog();
      return;
    }

    try {
      const productHandle = this.dataset.productHandle;
      const data = await this.fetchProductData(productHandle);
      this.updateSlotContent(data);
      this.showDialog();
    } catch (error) {
      console.error('Error handling open:', error);
    }
  }


  async fetchProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}?section_id=product-mobile-quick-add`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.text();
    } catch (error) {
      console.error('Error fetching product data:', error);
      throw error;
    }
  }

  updateSlotContent(data) {
    this.externalElements.slot.innerHTML = '';
    this.externalElements.slot.insertAdjacentHTML('beforeEnd', data);
  }

  showDialog() {
    const dialog = this.externalElements.slot.querySelector('[data-product-mobile-quick-add-el="dialog"]');
    dialog.show();
  }
}

customElements.define('product-mobile-quick-add-trigger', ProductMobileQuickAddTrigger);
